<template>
  <section class="main-containter clear">
    <!-- Data Input -->
    <Inputs  :inputData="inputData" />
    <div class="graphs">
      <div class="top">
        <div class="region">
          <Region />
          <!-- Region selector and share button area -->
        </div>
      </div>

      <div class="l-main-area">
        <div class="l-left">
          <Summary :summaryData="summaryChartStorage"
            :summaryDataNoStorage="summaryChartNoStorage"
            :inputData="summaryChartInputs"
            :isLoading="loading" />

          <!-- Electricity and Oil & Gas tabs -->
        </div>

        <div class="l-right">
          <!-- Sankey Diagram -->
          <Sankey
            
            :sankeyData="allSankey"
            :isLoading="loading"
            class="sankey"
          />
          <br />
          <!-- Time Series -->

            <Time 
              :timeData="allMWOutput"
              :timeDataNoStorage="allMWOutputNoStorage"
              :moneyData="timeSeriesDollar"
              :moneyDataNoStorage="timeSeriesDollarNoStorage"
              :emissionsData="timeSeriesEmissions"
              :emissionsDataNoStorage="timeSeriesEmissionsNoStorage"
              :capacityData="timeSeriesCapacity"
              :capacityDataNoStorage="timeSeriesCapacityNoStorage"
              :isLoading="loading" 
              class="time" 
            />

        </div>
      </div>
    </div>
    <div class="modal-container">
      <b-modal
        :visible="loadedBool"
        id="modal-hold"
        ref="modal-hold"
        title="Calculating Results"
        hide-footer
      >
        <b-container>
          <b-row>
            <b-col class="d-block text-center">
              Process could take up to a few minutes...<br />
            </b-col>
          </b-row>
          <b-row>
            <b-col class="d-block text-center">
              <div class="meter green">
                <span style="width: 100%"></span>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              &nbsp;
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button
                @click="$store.commit('setLoaded', false)"
                variant="danger"
                class="btn btn-block btn-icon-cancel"
              >
                <img
                  src="@/assets/images/icon_close.svg"
                  alt="Close"
                  width="15"
                />&nbsp; Cancel
              </b-button>
            </b-col>
          </b-row>
        </b-container>
        <footer></footer>
      </b-modal>
    </div>
  </section>
</template>

<script>
import Sankey from './Sankey.vue';
import Inputs from './Inputs.vue';
import Time from './Time.vue';
import Summary from './Summary.vue';
import Region from './Region.vue';
import Sample from '../assets/data/EIoF3.json';

// import axios from 'axios';
import { mapGetters, mapActions, mapState } from 'vuex';


export default {
  name: 'Layout',
  components: {
    Sankey,
    Inputs,
    Time,
    Summary,
    Region
  },
  data() {
    return {
      currentNode: {},
      sankeyData: {},
      loading: false,

      inputData: [],
      techMixInputs: [
        'Petroleum',
        'Nuclear',
        'Natural Gas',
        'Hydro',
        'Wind',
        'Coal',
        'Solar',
        'Biomass',
        'Geothermal'
      ],
      houseHoldInputs: ['Natural Gas', 'Electricity', 'Other'],
      Sample
    };
  },
  mounted() {
    this.fetchSampleTimeSeriesOutput();
  },
  methods: {
    ...mapActions(['fetchInputs', 'fetchSampleTimeSeriesOutput']),
    adjustInputData(data) {
      let sum = 0;
      let final = {};
      let links = data;
      links.forEach(link => {
        if (this.techMixInputs.includes(link.source)) {
          if (final[link.source]) {
            final[link.source] += link.value;
            sum += link.value;
          } else {
            final[link.source] = link.value;
            sum += link.value;
          }
        }
      });
      for (var prop in final) {
        final[prop] = parseFloat(((final[prop] / sum) * 100).toFixed(2));
      }

      return final;
    },
  },

  computed: {
    ...mapState(['timeSeries', 'summaryChartStorage', 'summaryChartNoStorage', 'summaryChartInputs', 'inputs', 'testSankey',
      'timeSeriesDollar', 'timeSeriesDollarNoStorage', 'timeSeriesEmissions', 'timeSeriesEmissionsNoStorage', 
      'timeSeriesCapacity', 'timeSeriesCapacityNoStorage', 'timeSeriesMW', 'storage', 'timeSeriesMWNoStorage'
      // {'series': state => state.timeSeriesMW}
      ]),
    ...mapGetters(['allSankey', 'allMWOutput', 'allMWOutputNoStorage']),
    loadedBool() {
      return this.$store.state.loading === true
    },
  },
  created() {
    // this.fetchSampleData();
    let data = Sample['sankey_links'];
    // let data2 = Sample['sankey_nodes'];
    // let data3 = Sample['Hourly_MW_AnnualStorage'];
    // this.sankeyData = this.adjustSankeyData(data, data2);
    this.inputData[0] = this.adjustInputData(data);
    this.inputData[1] = { value: 65.0 };
    this.inputData[2] = {
      'Natural Gas': 50.0,
      Electricity: 50.0,
      Other: 0.0
    };

    // this.fetchInputs();
  }
};
</script>

<style lang="scss">
.main-containter {
  max-width: 1800px;
  display: flex;
}

.graphs {
  display: flex;
  flex: 2;
  flex-direction: column;
}

.l-main-area {
  flex: 9;
  display: flex;
}

.l-left {
  padding: 10px;
  flex: 3;
  margin-left: 0.5rem;
  width: 525px;
  max-width: 525px;
  min-width: 525px;
}

.l-right {
  padding: 10px 17px 10px 10px;
  flex: 3;
  display: flex;
  flex-direction: column;
}

.sankey {
  flex: 1;
}

.time {
  flex: 1;
  // max-height: ;
}
</style>
